/* this file overrides all tables in the system (Table and MUIDataTable) */
export const Table = {
  MuiTableCell: {
    styleOverrides: {
      root: {
        padding: '4px 4px 4px 12px',
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      head: {
        height: '36px',
      },
    },
  },
  MUIDataTableHeadCell: {
    styleOverrides: {
      root: {
        padding: '4px 4px 4px 12px',
      },
    },
  },
  MUIDataTableToolbarSelect: {
    styleOverrides: {
      root: {
        borderRadius: 0,
      },
    },
  },
};
